import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, HorizontalPadding, responsiveImageSize } from '../common/responsive.utils';
import { AppStoreLink, PlayStoreLink,BrowserLink } from '../../data/urls';
import { isBrowser } from 'react-device-detect';
import ImageComponent from '../common/Image.component';
import ContentImage from '../../assets/image/mobile/content/home_content_download.png'
import ContentImageWeb from '../../assets/image/mobile/content/home_content_download.png'
import AppleWeb from '../../assets/icon/component/download/apple.svg';
import GoogleWeb from '../../assets/icon/component/download/google.svg';
import Google from '../../assets/icon/component/download/google.svg';
import Apple from '../../assets/icon/component/download/apple.svg';

const MainWebDownloadComponent = ({...props}) : React.ReactElement => {
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();

    const pressApple = () => {
        if(isBrowser){
            window.open(BrowserLink);
        }else {
            window.open(AppStoreLink, "_blank")
        }
    }

    const pressGoogle = () => {
        if(isBrowser){
            window.open(BrowserLink);
        }else {
            window.open(PlayStoreLink,  "_blank")
        }
    }

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.webComponent08_Web}>
                        <div style={styles.webColContainer01_Web}>
                            <span style={styles.webDownloadTitleText_Web}>
                                우리 아이 돌봐줄<br />

                                <span style={styles.webDownloadSemiTitleText_Web}>집 근처 견주/집사님</span>을<br />
                                지금 바로 만나보세요
                            </span>

                            <div style={{ height: 40 }} />
                            <div style={styles.webRowContainer01_Web} >
                                <div onClick={() => pressApple()}>
                                    <ImageComponent
                                        src={AppleWeb}
                                        alt=""
                                        style={styles.webImage08_Web}
                                        className='webImage08'
                                    />
                                </div>

                                <div style={{ width: 25 }} />
                                <div onClick={() => pressGoogle()}>
                                    <ImageComponent
                                        src={GoogleWeb}
                                        alt=""
                                        style={styles.webImage08_Web}
                                        className='webImage08'
                                    />
                                </div>
                            </div>
                        </div>

                        <ImageComponent
                            src={ContentImageWeb}
                            style={styles.webImage07_Web}
                            alt="imageComponent"
                        />
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.component04_Mobile} >
                        <div style={{ height: 10 }} />
                        <div style={styles.textContainer01_Mobile}>
                            <span style={styles.downloadTitleText_Mobile}>
                                우리 아이 돌봐줄
                            </span>

                            <span style={styles.downloadTitleText_Mobile}><span style={styles.downloadTitleBoldText_Mobile}>집 근처 견주/집사님</span>을</span>
                            <span style={styles.downloadTitleText_Mobile}>
                                지금 바로 만나보세요
                            </span>
                        </div>

                        <div style={{ height: 30 }} />
                        <div style={{ display: "flex", flexDirection:"column", justifyContent:"center", alignItems:"center" }}>

                            <div style={styles.component05_Mobile} >
                                <img src={Apple} alt="애플다운로드" style={styles.downloadButton_Mobile} className="downloadButton" onClick={() => pressApple()} />
                                <div style={{ width: 10 }} />
                                <img src={Google} alt="구글다운로드" style={styles.downloadButton_Mobile} className="downloadButton" onClick={() => pressGoogle()} />
                            </div>

                            <div style={{ height: 40 }} />
                            <img
                                src={ContentImage}
                                style={styles.componentImage02_Mobile}
                                alt="imageComponent"
                            />
                        </div>
                        <div style={{ height: 40 }} />
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    webComponent08_Web: { paddingRight: responsivePaddingHorizontal(24, 88), paddingLeft: responsivePaddingHorizontal(24,88) ,paddingTop: responsivePaddingVertical(40, 50), paddingBottom: responsivePaddingVertical(20, 35), width:"100%", display:"flex", flexDirection: "row", alignItems:"center", justifyContent:"space-between",backgroundColor:"#C7B4FF", boxSizing:"border-box"},
    webColContainer01_Web:{display:"flex", flexDirection:"column", alignItems:"flex-start", justifyContent:"flex-start"},
    webDownloadTitleText_Web: { fontFamily: "NanumSquareNeo", fontSize: responsiveFont(16,32), lineHeight: "140%", fontWeight:"700", letterSpacing:"-0.04em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", color:"#1B1D1F"},
    webDownloadSemiTitleText_Web: { fontFamily: "NanumSquareNeo", fontWeight: "900", fontSize: responsiveFont(20, 40), lineHeight: "140%", letterSpacing:"-0.02em", textAlign:"left",textUnderlinePosition:"from-font", textDecorationSkipInk:"none", color:"#1B1D1F" },
    webRowContainer01_Web: {width:"100%", display:"flex", flexDirection:"row", alignItems:"flex-start", justifyContent:"space-between", padding:"0px",margin:"0px"},
    webImage08_Web: { width: responsiveImageSize(130, 260), height: responsiveImageSize(34,68) },
    webImage07_Web: { width: responsiveImageSize(320, 640), height: responsiveImageSize(190, 380) },

    textContainer01_Mobile: { display: "flex", flexDirection: "column",  paddingRight: HorizontalPadding(24, 88), paddingLeft: HorizontalPadding(24, 88), paddingTop: responsivePaddingVertical(40, 50), paddingBottom: responsivePaddingVertical(20, 35), },
    component04_Mobile: { width: "100%", minWidth:"320px", display: "flex", flexDirection: "column", backgroundColor: "#C7B4FF" },
    component05_Mobile: { width: "100%", display: "flex", boxSizing: "border-box", flexDirection: "row", alignItems: "center", justifyContent: "center", paddingRight: HorizontalPadding(0, 24), paddingLeft: HorizontalPadding(0, 24)},
    downloadButton_Mobile: { width: responsiveImageSize(130, 260), height: responsiveImageSize(34, 68) },
    componentImage02_Mobile: { width: responsiveImageSize(320, 640), height: responsiveImageSize(190, 380) },
    downloadTitleText_Mobile: { fontFamily: "NanumSquareNeo", fontSize: responsiveFont(16, 32), lineHeight: "140%", fontWeight: "700", letterSpacing: "-0.02em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#1B1D1F" },
    downloadTitleBoldText_Mobile: { fontFamily: "NanumSquareNeo", fontSize: responsiveFont(20, 40), lineHeight: "140%", fontWeight: "900", letterSpacing: "-0.02em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#1B1D1F" },
});

export default MainWebDownloadComponent;